import { render, staticRenderFns } from "./NetaBulletinView.vue?vue&type=template&id=0c05806a&scoped=true&"
import script from "./NetaBulletinView.vue?vue&type=script&lang=js&"
export * from "./NetaBulletinView.vue?vue&type=script&lang=js&"
import style0 from "./NetaBulletinView.vue?vue&type=style&index=0&id=0c05806a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05806a",
  null
  
)

export default component.exports